package br.com.heyagenda.domain.usecase

import br.com.heyagenda.domain.model.Appointment
import br.com.heyagenda.domain.repository.AppointmentRepository

class GetAppointmentsPagedUseCase(
    private val repository: AppointmentRepository
) {
    suspend operator fun invoke(limit: Int = 20, startAfterDate: String? = null): List<Appointment> {
        return repository.getAppointmentsPaged(limit, startAfterDate)
    }
}
